export default __webpack_public_path__ + "static/media/flag-eu.396d5d9d.svg";